import * as React from 'react';
import * as styles from './styles.scss';
import {
    noCapturedResultsDescription,
    capturedResultsAutoPlacedDescription,
} from './TimestreamCapturedItems.locstring.json';
import { observer } from 'mobx-react-lite';
import capturedItems from '../selectors/capturedItems';
import loc from 'owa-localize';
import TimestreamSearchResult from './TimestreamSearchResult';
import { FocusZone } from '@fluentui/react/lib/FocusZone';
import { List } from '@fluentui/react/lib/List';
import type { SearchResultItem } from 'owa-timestream-asset-search';
import { isFeatureEnabled } from 'owa-feature-flags';

export default observer(function TimestreamCapturedItems() {
    const allCapturedItems = capturedItems();
    return allCapturedItems.length ? (
        <FocusZone>
            <List items={allCapturedItems} onRenderCell={renderCell} />
        </FocusZone>
    ) : (
        <div className={styles.noCapturedItemsWrapper}>
            <div className={styles.noCapturedItemsImage} />
            <div className={styles.noCapturedItemsDescription}>
                {isFeatureEnabled('cal-board-multipleBoards-dev')
                    ? loc(capturedResultsAutoPlacedDescription)
                    : loc(noCapturedResultsDescription)}
            </div>
        </div>
    );
});

function renderCell(item: SearchResultItem, index: number): JSX.Element {
    return (
        <div className={styles.capturedItemWrapper}>
            <TimestreamSearchResult highlightSearchTerms={false} item={item} key={index} />
        </div>
    );
}
